import { render, staticRenderFns } from "./pls-price-ui.vue?vue&type=template&id=e62bfad6"
import script from "./pls-price-ui.vue?vue&type=script&lang=ts"
export * from "./pls-price-ui.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports